import utils from './utils';

export default (() => {
    // Map languages to property ISO code
    const languageSet = {
        de: 'German',
        en: 'English',
        es: 'Spanish',
        fr: 'French',
        it: 'Italian',
        nl: 'Dutch',
    };

    return {
        exists: function (isoCode) {
            if (!isoCode) {
                return;
            }

            return !!languageSet[isoCode];
        },

        /**
         * Checks whether a user is whitelisted for the Booking Tool.
         *
         * @returns string
         */
        getLabel: function (isoCode) {
            if (!this.exists(isoCode)) {
                return;
            }

            return languageSet[isoCode];
        },

        /**
         * Returs the supported language choices
         *
         * @param {Array} supportedLanguages
         * @param {Function} translate
         *
         * @returns Array
         */

        getLanguageChoices: function (supportedLanguages, translate) {
            return utils.map(supportedLanguages, (language) => {
                const languageName = this.getLabel(language).toLowerCase();

                return {
                    label: translate(`languages.${ languageName }`),
                    value: language,
                };
            }
            );
        },
    };
})();



// WEBPACK FOOTER //
// ./src/helpers/languages.js